import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import TimeLineItem from './TimeLineItem'

import { useEffect } from 'react'
import { faHourglass } from '@fortawesome/free-solid-svg-icons'

const TimeLine = (props) => {
	useEffect(() => {
		const observer = target => {
			const io = new IntersectionObserver((entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						entry.target.classList.add('tg23-show');
					}
					else {
						entry.target.classList.remove('tg23-show');
					}
				});
			});
			io.observe(target);
		}
		const hiddenEle = document.querySelectorAll('.tg23-hidden');
		hiddenEle.forEach(ele => { observer(ele) });
	}, [])

	return (
		<div className='tg23-timeLine-wrapper'>
			<p className='tg23-section-heading' data-value="TIMELINE" onMouseOver={props.mouseHover}>TIMELINE</p>
			{/* <div className='tg23-line tg23-hidden' /> */}
			
			<span className="tg23-connector">
				<FontAwesomeIcon icon={faHourglass} />
			</span>

			<TimeLineItem
				borderStyle='tg23-left-border'
				title={"Registrations Start"}
				description={""}
				time={"8th September 2023"}
				info={"Online Registrations is started, the form for the same will be available at the top of this page."}
			/>
			<div className='tg23-line tg23-hidden' />

			<TimeLineItem
				borderStyle='tg23-right-border'
				title={"Registrations End"}
				description={""}
				time={<span className='tg23-lineHeight'><p>14th September 2023</p><p>12:00PM</p></span>}
				info={"Registrations end. Registered teams kindly go through the guidelines"}
			/>
			<div className='tg23-line tg23-hidden' />
			
			<TimeLineItem
				borderStyle='tg23-left-border'
				title={"Events starts!"}
				time={<span className='tg23-lineHeight'><p>15th September 2023</p><p>10:30AM</p></span>}
				info={"Event inaugration, team registration and teams announcement will happen at sharp 10:30AM"}
			/>
			<div className='tg23-line tg23-hidden' />
			
			<TimeLineItem
				borderStyle='tg23-right-border'
				title={"Quiz round"}
				time={<span className='tg23-lineHeight'><p>15th September 2023</p><p>11:30AM - 12:30AM</p></span>}
				info={"A coding quiz round to challenge your tech knowledge, followed by a break of one hour."}
				/>
			<div className='tg23-line tg23-hidden' />
			
			<TimeLineItem
				borderStyle='tg23-left-border'
				title={"Bug Bounty"}
				time={<span className='tg23-lineHeight'><p>15th September 2023</p><p>1:30PM - 3:30PM</p></span>}
				info={"Selected teams will be tested on their debugging skills in this round."}
			/>
			<div className='tg23-line tg23-hidden' />
			
			<TimeLineItem
				borderStyle='tg23-right-border'
				title={"Day 2 Begins!"}
				time={<span className='tg23-lineHeight'><p>16th September 2023</p><p>10:00AM</p></span>}
				info={"Second day begins with a short assembly for the shortlisted teams."}
			/>
			<div className='tg23-line tg23-hidden' />

			<TimeLineItem
				borderStyle='tg23-left-border'
				title={"Minute-To-Win-It"}
				time={<span className='tg23-lineHeight'><p>16th September 2023</p><p>11:00AM - 12:00AM</p></span>}
				info={"Next round involves testing your quick adaptive thinking, followed by a break of one hour."}
			/>
			<div className='tg23-line tg23-hidden' />

			<TimeLineItem
				borderStyle='tg23-right-border'
				title={"Finale Round"}
				time={<span className='tg23-lineHeight'><p>16th September 2023</p><p>1:00PM - 3:30PM</p></span>}
				info={"The selected finalists will compete for the grand prize in this `mystery round` (details will be shared on the spot only)"}
			/>
			<div className='tg23-line tg23-hidden' />

			<TimeLineItem
				borderStyle='tg23-left-border bottom-none'
				title={"Closing Ceremony"}
				time={<span className='tg23-lineHeight'><p>16th September 2023</p><p>4:00PM - 5:00PM</p></span>}
				info={"As the first event of DJS-NSDC comes to an end, we thank all of the faculty with this closing ceremony and announce the rightful winners 🥳"}
			/>
			<div className='tg23-line tg23-hidden' />
			
			<span className="connector right">
				<i className="fa fa-hourglass-o" />
			</span>
		</div>
	)
}

export default TimeLine